import React, { memo } from "react";
import { Dropdown } from "react-bootstrap";
import { HiMenuAlt1 } from "react-icons/hi";
const CustomDropDown = ({ dropDownOptions, className, ...props }) => {
  return (
    <Dropdown className={className}>
      <Dropdown.Toggle
        id="dropdown-autoclose-true"
        className="btn-outline-secondary icon_button"
      >
        <HiMenuAlt1 size={18} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Object.keys(dropDownOptions).map((key, i) => (
          <Dropdown.Item
            href="#"
            onClick={dropDownOptions[key].onClick}
            key={i}
            disabled={dropDownOptions[key].disabled}
          >
            {key}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default memo(CustomDropDown);

// return (
//   <Dropdown className="d-inline ">
//     <Dropdown.Toggle
//       id="dropdown-autoclose-true"
//       className="btn_user_box"
//       style={{
//         padding: 0,
//         background: "none",
//         border: "none",
//       }}
//     >
//       <LiaUserCircleSolid fontSize={"22px"} />
//       <span>
//         {name} <TiArrowSortedDown />
//       </span>
//     </Dropdown.Toggle>

//     <Dropdown.Menu>
//       <Dropdown.Item href="#" onClick={onClick}>
//         <Icon name="FaPowerOff" className="fs-18 me-1 align-text-bottom" />
//         Logout
//       </Dropdown.Item>
//     </Dropdown.Menu>
//   </Dropdown>
// );
